import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    // Not logged in: redirect with tracking path
    return <Navigate to="/" replace state={{ path: location.pathname }} />;
  }
  return children;
}
